
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ErrorResponse } from '@gtpl/shared-models/common-models';

export function errorHandler<T extends GlobalResponseObject>(classType: { new(): T }, errorObj: ErrorResponse): T {
    let intlCode;
    let message;
    let statusCode;
    if (errorObj.intlCode) {
        intlCode = errorObj.intlCode;
        message = errorObj.message;
        if(errorObj.statusCode) {
            statusCode = errorObj.statusCode;
        } else {
            statusCode = 40000;
        }
    } else {
        intlCode = 0;
        statusCode = 40000;
        message = errorObj.message;
    }
    const responseObj = new classType();
    responseObj.status = false;
    responseObj.statusCode = statusCode;
    responseObj.intlCode = intlCode;
    responseObj.internalMessage = message;

    return responseObj;
}
